import { curryN, gte, is } from 'ramda';

// Vérification pour voir si une erreur a une valeur entre 200 et 299
export const isWithin = curryN(3, (min, max, value) => {
  const isNumber = is(Number);
  return isNumber(min) && isNumber(max) && isNumber(value) && gte(value, min) && gte(max, value);
});


export const in200s = isWithin(200, 299);